export default "__VITE_ASSET__C6d9S_0G__"